import produce from 'immer';
import { types } from '../actions/locale';
var DEFAULT_LANG = 'en-US';
var initialState = {
    lang: DEFAULT_LANG,
    messages: undefined,
};
var setLocale = function (state, payload) {
    return produce(state, function (draftState) {
        var lang = payload.lang, messages = payload.messages;
        draftState.lang = lang;
        draftState.messages = messages;
    });
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case types.SET_LOCALE:
            return setLocale(state, payload);
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=locale.js.map